import React from 'react';
import { SearchButton } from '../buttons/iconButtons/SearchButton';
import './Search.scss';

export interface SearchProps {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  value?: string;
  placeholder?: string;
  className?: string;
}

export function Search({
  onChange,
  onKeyDown,
  value,
  placeholder,
  className,
  ...rest
}: SearchProps) {
  return (
    <div className={`search-container ${className}`} {...rest}>
      <input
        className="search-input" 
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder ?? 'Search'}
        value={value}
      />
      <SearchButton width={16} height={16} />
    </div>
  );
}
